// Maximalwert für SINGLE PRECISION
const MAX_VALUE_FLOAT = 3.4e+38;
const MAX_VALUE_INTEGER = 2147483647;



// Funktion zur Ausgabe des aktuellen Zeitstempels für die Datenbank formatiert
export const formatTimestampNow = () => {
    const now = new Date() //.toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };


// Funktion zur Ausgabe des Zeitstempels in der Tabelle
export const formatTimestampView = (timestamp) => {
  const dateObj = new Date(timestamp);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  };

  
  // Funktionen zur Behandlung von Fehleingaben und Umwandlung von Komma in Punkt bei float-Feldern:
  // Hilfsfunktion, um Felder mit { float: true } zu finden, Komma in Punkt zu ersetzen und in Floats zu konvertieren
  export const convertCommaToDotForFloatFields = (post, fields, fieldConfigurations = {}) => {
    // Fallback, falls fieldConfigurations leer ist
    const configurations = fieldConfigurations ? Object.values(fieldConfigurations).flat() : [];

    // Zusammenfuehren der relevanten Felder: nur `fields` oder zusaetzlich `fieldConfigurations`, falls vorhanden
    const allFields = [...fields, ...configurations];

    // Iteriere durch alle Felder und pruefe auf die float-Validierung
    allFields.forEach((field) => {
      if (field.validate && field.validate.float && post[field.name]) {
        // Konvertiere den Wert zu einem String, ersetze Komma durch Punkt und versuche, es in einen Float zu wandeln
        const value = String(post[field.name]).replace(',', '.');
        const floatValue = parseFloat(value);

        // Ueberpruefe, ob der Wert erfolgreich in einen Float konvertiert wurde, bevor er zurueckgeschrieben wird
        if (!isNaN(floatValue)) {
          post[field.name] = floatValue;
        } else {
          console.warn(`Wert von ${field.name} konnte nicht in einen Float umgewandelt werden: ${value}`);
        }
      }
    });
  };


 
  /**
   * Ueberprueft, ob Float- oder Integer-Felder leer sind, und setzt sie auf den Wert -123.
   * Diese Funktion unterstützt sowohl `fields` als auch `fieldConfigurations`.
   * @param {Object} post - Der Datensatz, der überprüft und angepasst werden soll.
   * @param {Array} fields - Die Liste der Felder, die als einfacher Array vorliegen.
   * @param {Object} fieldConfigurations - Optionales Konfigurationsobjekt, das zusaetzliche Felder enthaelt.
   */
  export const setDefaultForEmptyNumberFields = (post, fields, fieldConfigurations = {}) => {
    // Fallback, falls fieldConfigurations leer ist
    const configurations = fieldConfigurations ? Object.values(fieldConfigurations).flat() : [];

    // Zusammenfuehren der relevanten Felder: nur `fields` oder zusaetzlich `fieldConfigurations`, falls vorhanden
    const allFields = [...fields, ...configurations];

    // Iteriere durch alle Felder und prüfe, ob das Feld als `float` oder `integer` deklariert ist
    allFields.forEach((field) => {
      // Sicherstellen, dass field.validate existiert und eine gültige Struktur hat
      if (field.validate && (field.validate.float || field.validate.integer)) {
        const fieldName = field.name;
        const fieldValue = post[fieldName];

        // Überprüfen, ob das Feld leer ist (nicht bei 0) und falls ja, auf -123 setzen
        if ((fieldValue === '' || fieldValue === null || fieldValue === undefined)) {
          if (field.validate.float) {
            post[fieldName] = -123;
          } else if (field.validate.integer) {
            post[fieldName] = -123;
          }
        }
      }
    });
  };

 
  // Funktion zur Behandlung des gesetzten Fokus
  export const handleFocus = (event, setErrors) => {
    const { name } = event.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Fehler für dieses Feld zurücksetzen
    }));
  };


  // Funktion zur Behandlung des onBlur-Ereignisses
  export const handleBlur = (event, fields, fieldConfigurations = {}, validateField) => {
    const { name, value } = event.target;

    // Fallback, falls fieldConfigurations leer ist
    const configurations = fieldConfigurations ? Object.values(fieldConfigurations).flat() : [];

    // Ueberpruefe die Felder aus den aktuellen Konfigurationen
    const fieldConfig = 
      configurations.find((f) => f.name === name) || fields.find((f) => f.name === name);

    if (!fieldConfig) {
      console.error(`Kein Feld mit dem Namen ${name} gefunden.`);
      return;
    }

    const rules = fieldConfig.validate || {};
    validateField(name, value, rules);
  };


  // Funktion zur Ueberpruefung, ob Felder den gesetzten Bedingungen entsprechen
  export const validateField = (name, value, rules = {}, setErrors) => {
    let error = '';
    const valueStr = value != null ? String(value).trim() : ''; // Konvertiere nur, falls nötig
  
    // Regel: Feld darf nicht leer sein, wenn `required: true`
    if (rules.required && valueStr === '') {
      error = 'Dieses Feld darf nicht leer sein!';
    }
  
    // Regel: Nur Integer-Werte erlauben
    else if (rules.integer && valueStr !== '') {     
      const integerRegex = /^-?\d+$/;
      if (!integerRegex.test(valueStr)) {
        error = 'Ungültiger Wert: nur Ganzzahlen sind erlaubt!';
      } else if (parseInt(valueStr) < 0) {
        error = 'Ungültiger Wert: nur positive Ganzzahlen sind erlaubt!';
      } else if (parseInt(valueStr) > MAX_VALUE_INTEGER) {
        error = `Ungültiger Wert: Die Zahl darf maximal ${MAX_VALUE_INTEGER} betragen!`;
      }
    }
  
    // Regel: Nur Float-Werte erlauben
    else if (rules.float && valueStr !== '') {
      const conversionPointValue = valueStr.replace(',', '.');
  
      const floatRegex = /^-?\d+(\.\d+)?$/;
      if (!floatRegex.test(conversionPointValue)) {
        error = 'Ungültiger Wert: nur Zahlen sind erlaubt!';
      } else if (parseFloat(conversionPointValue) < 0) {
        error = 'Ungültiger Wert: nur positive Zahlen sind erlaubt!';
      } else if (parseFloat(conversionPointValue) > MAX_VALUE_FLOAT) {
        error = `Ungültiger Wert: Die Zahl darf maximal ${MAX_VALUE_FLOAT} betragen!`;
      }
    }
  
    // Regel: E-Mail-Adresse validieren
    else if (rules.email && valueStr !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      if (!emailRegex.test(valueStr)) {
        error = 'Ungültige E-Mail-Adresse!';
      }
    }
  
    // Fehler im Zustand setzen
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    return error;
  };
  

